export default __webpack_public_path__ + "static/media/hourglass.fa34c9c7.svg";